import { render, staticRenderFns } from "./detailOrderModal.vue?vue&type=template&id=e40ccd1c&scoped=true"
import script from "./detailOrderModal.vue?vue&type=script&lang=js"
export * from "./detailOrderModal.vue?vue&type=script&lang=js"
import style0 from "./detailOrderModal.vue?vue&type=style&index=0&id=e40ccd1c&prod&lang=css"
import style1 from "./detailOrderModal.vue?vue&type=style&index=1&id=e40ccd1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e40ccd1c",
  null
  
)

export default component.exports